module.exports = __webpack_public_path__ + "media/images/obeecs-e68dc5c23a9d969edd0e9d0a77043079.png";